import { Row } from "react-bootstrap";
import { useFusaOrganizationStore } from "../../store/FusaOrganizationStore";
import { FusaOrganization } from "@/backend/models/fusaOrganization";
import { I18n } from "@/i18n/I18n";
import { useGlobalStore } from "../../store/GlobalStore";
import { FileSubjectTypes } from "@/types/fileTypes";
import { HierarchyCard } from "./HierarchyCard";
import { CreateHierarchyModelButton } from "../buttons/CreateHierarchyModelButton";
import { useEffect, useState } from "react";
import { CardPlaceholder } from "./CardPlaceholder";

export function FusaOrganizationCards() {
  const fusaOrganizations = useFusaOrganizationStore(state => state.fusaOrganizations);
  const enterprise = useGlobalStore(state => state.enterprise);
  const fetchFusaOrganizationsByEnterpriseId = useFusaOrganizationStore(state => state.fetchFusaOrganizationsByEnterpriseId);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (enterprise?.id) {
      setLoading(true);
      void fetchFusaOrganizationsByEnterpriseId(enterprise.id).finally(() => {
        setLoading(false);
      });
    }
  }, [enterprise, fetchFusaOrganizationsByEnterpriseId]);

  if (loading) {
    return <CardPlaceholder />;
  }

  return (
    <div className="p-3 overflow-auto" style={{ maxHeight: '100vh', height: '100vh' }}>
    <div className="pb-4">
      <h1>{I18n.get('organizations')}</h1>
    </div>
      <CreateFusaOrganizationButton />
      {fusaOrganizations.length === 0 && (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
          <h3>{I18n.get('noOrganizations')}</h3>
        </div>
      )}
      <Row xs={1} md={2} lg={4} className="py-5 g-4">
        {fusaOrganizations.map((fusaOrganization) => (
          <FusaOrganizationCard key={fusaOrganization.id} fusaOrganization={fusaOrganization} />
        ))}
    </Row>
  </div>
  );
}

function FusaOrganizationCard(props: { fusaOrganization: FusaOrganization }) {
  const { fusaOrganization } = props;
  const { deleteFusaOrganization, updateFusaOrganization, refetchFusaOrganization } = useFusaOrganizationStore();

  return (
    <HierarchyCard
      model={fusaOrganization}
      titleLink={`/fusa-organizations/${fusaOrganization.id}`}
      modelLabel={I18n.get('fusaOrganization')}
      updateModel={updateFusaOrganization}
      deleteModel={deleteFusaOrganization}
      subjectType={FileSubjectTypes.FUSA_ORGANIZATION}
      refetchSubject={refetchFusaOrganization}
    />
  );
}

function CreateFusaOrganizationButton() {
  const createFusaOrganization = useFusaOrganizationStore(state => state.createFusaOrganization);
  const refetchFusaOrganization = useFusaOrganizationStore(state => state.refetchFusaOrganization);
  const enterprise = useGlobalStore(state => state.enterprise);

  const handleCreate = async (title: string, description: string): Promise<string | undefined> => {
    const response = await createFusaOrganization({ 
      title, 
      description, 
      enterpriseId: enterprise?.id || '' 
    });
    return response.fusaOrganization?.id;
  };

  return (
    <CreateHierarchyModelButton createModel={handleCreate} modelLabel={I18n.get('fusaOrganization')} refetchSubject={refetchFusaOrganization} subjectType={FileSubjectTypes.FUSA_ORGANIZATION}></CreateHierarchyModelButton>
  );
}
